import styled from 'styled-components';
import { Head } from '@/features/pages/home';

export const SimilarHead = styled(Head)`
  @media (max-width: 800px) {
    text-align: center;
    align-items: center;
  }
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  position: relative;
  z-index: 10;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);

    > *:nth-child(3) {
      display: none;
    }
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);

    > *:nth-child(2) {
      display: none;
    }
  }
`;
